module.exports = __webpack_public_path__ + "static/media/loader.de2d1f3f.gif";